export default "__VITE_ASSET__D7UCNhC2__"